import { useState, useEffect, useCallback } from 'react';
import { useSession } from 'next-auth/react';

// Прост hook за броя книги в header
export function useBooksCount() {
  const { data: session } = useSession();
  const isLoggedIn = Boolean(session?.user);

  const [count, setCount] = useState(0);

  // Функция за зареждане на броя книги
  const loadCount = useCallback(() => {
    if (isLoggedIn) {
      // За логнати потребители - зареждаме от database
      fetch('/api/books')
        .then((response) => (response.ok ? response.json() : { books: [] }))
        .then((data) => {
          setCount(data.books?.length || 0);
        })
        .catch(() => {
          setCount(0);
        });
    } else {
      // За неавтентифицирани потребители - зареждаме от localStorage
      try {
        const savedBooks = localStorage.getItem('savedBooks');
        const books = savedBooks ? JSON.parse(savedBooks) : [];
        setCount(books.length);
      } catch {
        setCount(0);
      }
    }
  }, [isLoggedIn]);

  // Зареждаме броя при mount
  useEffect(() => {
    loadCount();
  }, [loadCount]);

  // Слушаме за промени в книги
  useEffect(() => {
    const handleBooksChanged = () => {
      loadCount();
    };

    window.addEventListener('booksChanged', handleBooksChanged);
    window.addEventListener('savedBooksChanged', handleBooksChanged);

    return () => {
      window.removeEventListener('booksChanged', handleBooksChanged);
      window.removeEventListener('savedBooksChanged', handleBooksChanged);
    };
  }, [loadCount]);

  return count;
}
